import { api } from "@/api";
import type { ResponseDto, ResponseListDto } from "@/types/domain";
import type { AiAccountSubscription, AiUserAccessRow, TokenUsageDay } from "./types";

export const fetchAiSubscription = async (): Promise<AiAccountSubscription | null> => {
  const response = await api.get<ResponseDto<AiAccountSubscription> | null>("/featuresubscriptions");
  return response.data?.data ?? null;
};

export const fetchAiTokenUsage = async (yearMonth?: string): Promise<TokenUsageDay[]> => {
  const response = await api.get<ResponseListDto<TokenUsageDay>>("/tokenusage", { params: yearMonth ? { yearMonth } : undefined });
  return response.data.data;
};

export const fetchAiUserAccess = async (): Promise<AiUserAccessRow[]> => {
  const response = await api.get<ResponseListDto<Omit<AiUserAccessRow, "id">>>("/featuresubscriptions/useraccess");
  return response.data.data.map((user) => ({ ...user, id: user.userId }));
};

export const revokeAiUserAccess = async (userId: string): Promise<void> => {
  await api.delete(`/featuresubscriptions/useraccess/${userId}`);
};

export const revokeAllAiUserAccess = async (): Promise<void> => {
  await api.delete("/featuresubscriptions/useraccess");
};

export const grantAiUserAccess = async (userId: string): Promise<void> => {
  await api.post(`/featuresubscriptions/useraccess/${userId}`);
};

export const updateAiAccessMode = async (grantAllUsers: boolean): Promise<void> => {
  await api.put("/featuresubscriptions/accessmode", { grantAllUsers });
};
